(() => {
  const focusable = 'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const init = (root) => {
    if (!root || root.dataset.orlisseReady === 'true') return;
    root.dataset.orlisseReady = 'true';
    const drawer = root.querySelector('[data-orlisse-drawer]');
    const opener = root.querySelector('[data-orlisse-drawer-open]');
    let returnFocus = null;
    const closeDrawer = () => { if (!drawer || drawer.hidden) return; drawer.classList.remove('is-open'); document.documentElement.classList.remove('orlisse-menu-open'); opener?.setAttribute('aria-expanded','false'); window.setTimeout(() => { drawer.hidden = true; returnFocus?.focus(); }, 320); };
    const openDrawer = () => { if (!drawer) return; returnFocus = document.activeElement; drawer.hidden = false; requestAnimationFrame(() => { drawer.classList.add('is-open'); document.documentElement.classList.add('orlisse-menu-open'); opener?.setAttribute('aria-expanded','true'); drawer.querySelector(focusable)?.focus(); }); };
    opener?.addEventListener('click', openDrawer);
    drawer?.querySelectorAll('[data-orlisse-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    drawer?.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); if (event.key !== 'Tab') return; const items=[...drawer.querySelectorAll(focusable)]; if (!items.length) return; const first=items[0], last=items.at(-1); if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()} });
    const setMega = (trigger, open) => { const panel=document.getElementById(trigger.getAttribute('aria-controls')); trigger.setAttribute('aria-expanded',String(open)); if(!panel) return; if(open){panel.hidden=false;requestAnimationFrame(()=>panel.classList.add('is-open'))}else{panel.classList.remove('is-open');window.setTimeout(()=>{if(!panel.classList.contains('is-open'))panel.hidden=true},330)} };
    const closeMegas = (except) => root.querySelectorAll('[data-orlisse-mega-trigger]').forEach((trigger) => { if(trigger!==except) setMega(trigger,false); });
    root.querySelectorAll('[data-orlisse-mega-trigger]').forEach((trigger) => { const toggle=(open) => { closeMegas(open?trigger:null); setMega(trigger,open); }; trigger.addEventListener('click',()=>toggle(trigger.getAttribute('aria-expanded')!=='true')); trigger.parentElement?.addEventListener('mouseenter',()=>toggle(true)); trigger.parentElement?.addEventListener('mouseleave',()=>toggle(false)); trigger.addEventListener('keydown',(event)=>{if(event.key==='Escape'){toggle(false);trigger.focus()}}); });
    root.querySelectorAll('[data-orlisse-localization]').forEach((select)=>select.addEventListener('change',()=>select.form?.submit()));
    document.addEventListener('click',(event)=>{if(!root.contains(event.target)) closeMegas();});
  };
  const initAll = (scope=document) => scope.querySelectorAll('[data-orlisse-header]').forEach(init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initAll()); else initAll();
  document.addEventListener('shopify:section:load',(event)=>initAll(event.target));
})();


/*
 * Announcement ticker.
 *
 * Repeats the group of announcements until it overfills the bar, then lets
 * the CSS slide the track left by exactly one group width on a loop. Because
 * the frame at the end of the loop is identical to the first, there is no
 * visible seam. Without this script the announcements sit in a static row.
 *
 * The ticker pauses on hover (CSS), while a touch is held, and from the pause
 * button. It stands still while a link inside it has keyboard focus, and never
 * starts for customers who ask for reduced motion.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (bar) => {
    if (bar.dataset.announcementReady === 'true') return;

    const viewport = bar.querySelector('[data-announcement-viewport]');
    const track = bar.querySelector('[data-announcement-track]');
    const group = bar.querySelector('[data-announcement-group]');
    if (!viewport || !track || !group || !group.children.length) return;

    bar.dataset.announcementReady = 'true';

    const toggle = bar.querySelector('[data-announcement-toggle]');
    const speed = Math.max(10, Number(bar.dataset.speed) || 50); // px per second
    let builtFor = '';

    // Copies are decoration: hidden from assistive tech, out of the tab order,
    // and stripped of theme-editor attributes so blocks are not duplicated.
    const makeCopy = () => {
      const copy = group.cloneNode(true);
      copy.removeAttribute('data-announcement-group');
      copy.dataset.announcementCopy = '';
      copy.setAttribute('aria-hidden', 'true');
      copy.inert = true;
      copy.querySelectorAll('*').forEach((node) => {
        [...node.attributes]
          .filter((attribute) => attribute.name.startsWith('data-shopify'))
          .forEach((attribute) => node.removeAttribute(attribute.name));
      });
      return copy;
    };

    const build = () => {
      const groupWidth = group.getBoundingClientRect().width;
      const viewportWidth = viewport.clientWidth;
      const key = `${reduceMotion.matches}|${Math.round(groupWidth)}|${viewportWidth}`;
      if (key === builtFor) return;
      builtFor = key;

      track.querySelectorAll('[data-announcement-copy]').forEach((copy) => copy.remove());
      bar.classList.remove('is-ticking');
      if (toggle) toggle.hidden = true;

      if (reduceMotion.matches || !groupWidth || !viewportWidth) return;

      // One extra copy beyond what fills the bar keeps the right edge covered
      // for the whole of the one-group shift.
      const copies = Math.ceil(viewportWidth / groupWidth) + 1;
      for (let i = 0; i < copies; i += 1) track.append(makeCopy());

      bar.style.setProperty('--announcement-shift', `${groupWidth}px`);
      bar.style.setProperty('--announcement-duration', `${groupWidth / speed}s`);
      bar.classList.add('is-ticking');
      if (toggle) toggle.hidden = false;
    };

    // Web fonts and window resizes both change the measurements.
    let frame = 0;
    const observer = new ResizeObserver(() => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(build);
    });
    observer.observe(viewport);
    observer.observe(group);
    reduceMotion.addEventListener('change', build);

    toggle?.addEventListener('click', () => {
      const paused = !bar.classList.contains('is-paused');
      bar.classList.toggle('is-paused', paused);
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
    });

    // Touch has no hover, so pressing and holding the ticker pauses it.
    const release = () => bar.classList.remove('is-held');
    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') bar.classList.add('is-held');
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((type) => viewport.addEventListener(type, release));

    // Keyboard focus on a link: hold the ticker at its start so the focused
    // link is a real, visible target rather than something sliding away.
    const setStill = (still) => {
      bar.classList.toggle('is-still', still);
      if (!still) viewport.scrollLeft = 0;
    };
    viewport.addEventListener('focusin', () => setStill(true));
    viewport.addEventListener('focusout', (event) => {
      if (!viewport.contains(event.relatedTarget)) setStill(false);
    });

    // Theme editor: a selected announcement block should be findable.
    bar.addEventListener('shopify:block:select', () => setStill(true));
    bar.addEventListener('shopify:block:deselect', () => setStill(false));

    build();
  };

  const initAll = (scope = document) =>
    scope.querySelectorAll('[data-orlisse-announcement]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();


/*
 * Scroll-direction header.
 *
 * Scrolling down past the reveal threshold slides the sticky shell out of view;
 * any upward scroll pops it back. One passive listener, rAF-throttled, shared by
 * every header instance on the page.
 */
(() => {
  const HIDE_AFTER = 140; // px scrolled before hiding is allowed at all
  const DELTA = 6; // ignore sub-pixel jitter and trackpad noise

  const headers = () => document.querySelectorAll('[data-orlisse-header]');

  let lastY = window.scrollY;
  let ticking = false;

  const isBlocked = (header) =>
    // Never hide the header out from under an open menu or search overlay.
    document.documentElement.classList.contains('orlisse-menu-open') ||
    header.querySelector('[data-orlisse-mega-trigger][aria-expanded="true"]') !== null;

  const apply = () => {
    ticking = false;

    const y = Math.max(0, window.scrollY);
    const diff = y - lastY;

    if (Math.abs(diff) < DELTA) return;

    const goingDown = diff > 0;
    lastY = y;

    headers().forEach((header) => {
      if (header.dataset.sticky !== 'true') return;

      header.classList.toggle('is-scrolled', y > 4);

      if (isBlocked(header) || y <= HIDE_AFTER) {
        header.classList.remove('is-hidden');
        return;
      }

      header.classList.toggle('is-hidden', goingDown);
    });
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  };

  // The sticky wrapper is offset upward by exactly the announcement height so
  // the announcement scrolls away while the nav bar pins to the top.
  const measure = () => {
    headers().forEach((header) => {
      const wrapper = header.parentElement;
      if (!wrapper) return;
      const bar = header.querySelector('.orlisse-announcement');
      const height = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      wrapper.style.setProperty('--orlisse-announcement-height', height + 'px');
    });
  };

  measure();
  window.addEventListener('resize', measure, { passive: true });

  window.addEventListener('scroll', onScroll, { passive: true });

  // A focus landing inside a hidden header (keyboard tabbing, skip links)
  // must bring it back rather than move focus somewhere invisible.
  document.addEventListener('focusin', (event) => {
    const header = event.target.closest?.('[data-orlisse-header]');
    if (header) header.classList.remove('is-hidden');
  });

  onScroll();
})();
